import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Crucible's type scale (`text-display-xl` … `text-caption`, see ds-typography.css)
 * are custom font-size utilities. tailwind-merge treats unknown `text-*` as color,
 * so `cn('text-body text-secondary')` silently becomes `text-secondary` (16px body).
 * Register the ladder under `font-size` so size + color coexist — matches scaffold app.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display-xl',
            'hero',
            'metric',
            'display',
            'title',
            'heading',
            'body',
            'label',
            'caption',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
